import { render, staticRenderFns } from "./StoreMarketingTwo.vue?vue&type=template&id=630d2b77&scoped=true"
import script from "./StoreMarketingTwo.vue?vue&type=script&lang=js"
export * from "./StoreMarketingTwo.vue?vue&type=script&lang=js"
import style0 from "./StoreMarketingTwo.vue?vue&type=style&index=0&id=630d2b77&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630d2b77",
  null
  
)

export default component.exports